import compact from "lodash/compact";

export default function isActive(router, route, regexp) {
  const checkRoute=compact(route.split('/'));
  if(!regexp) {
    regexp=`/${checkRoute.join('/')}.*`;
  }
  if(route==='/') {
    if(router.location.pathname===route) {
      return true;
    }
  } else {
    const reg = new RegExp(regexp, 'g');

    //console.log(regexp,router.location.pathname,reg.test(router.location.pathname));
    return reg.test(router.location.pathname);
  }

  return false;

  /*
  const curRoute=compact(router.location.pathname.split('/'));
  const checkRoute=compact(route.split('/'));

  if(curRoute.length===0) {
    if(checkRoute.length===0) {
      return true;
    } else {
      return false;
    }
  }

  if(checkDepth+1>curRoute.length) {
    checkDepth=checkRoute.length-1;
    console.log('replace checkDepth',checkDepth,checkRoute);
  }

  for(let i=0;i<=checkDepth;i++) {
    if(curRoute[i]!==checkRoute[i]) {
      return false;
    }
  }

  if(options.exact) {
    if(curRoute.length===checkRoute.length) {
      return true;
    } else {
      return false;
    }
  }

  return true;
  */
}